import { render } from "./KDPSalesNoteHeaderNavigationContainer.vue?vue&type=template&id=931af0ce&scoped=true&ts=true"
import script from "./KDPSalesNoteHeaderNavigationContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./KDPSalesNoteHeaderNavigationContainer.vue?vue&type=script&setup=true&lang=ts"

import "./KDPSalesNoteHeaderNavigationContainer.vue?vue&type=style&index=0&id=931af0ce&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-931af0ce"],['__file',"src/components/KDPSalesNoteHeaderNavigationContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "931af0ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('931af0ce', __exports__)) {
    console.log('reload')
    api.reload('931af0ce', __exports__)
  }
  
  module.hot.accept("./KDPSalesNoteHeaderNavigationContainer.vue?vue&type=template&id=931af0ce&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('931af0ce', render)
  })

}


export default __exports__